module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_5012.e39975a9.png";